<template>
    <el-select v-model="choosedValue"  v-bind="$attrs" @change="changeOption" >
        <el-option v-for="item in optionsC" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
</template>

<script>
export default {
    name: "MineSelect",

    model: {
        prop: "selected",
        event: "change"
    },

    props: {


        selected: {
            type: [String,Number,Boolean,Array]
        },

        /**
         * 选中的值不存在时，默认选中第一个选项
         */
        defaultFirst: {
            type: Boolean,
            default: false
        },

        /**
         * 一个也没选中时的值
         */
        noneValue: {
            type: [String, Number, Boolean, Array],
            default: null
        },


        options: { //指定选项
            type: Array,
            required: false
        },
        url: { //指定加载路径
            type: String,
            required: false
        },
        valueField: { //值对应的字段名称
            type: String,
            required: false,
            default: "id",
        },
        labelField: { //文字对应的字段名称
            type: String,
            required: false,
            default: "name",
        }
    },

    data() {
        return {
            //是否完成初始化
            initDone: false,
            //选项
            items: [],

            choosedValue: null,
        }

    },

    computed: {
        optionsC() {
            if (this.initDone == false) return [];
            return this.items.map(item => ({value: item[this.valueField], label: item[this.labelField]}));
        }
    },

    watch: {
        "selected": function(newV, oldV) {
            if (newV != this.choosedValue) {
                console.debug("值变了", newV);
                this.processChoosed();
            }
        },

        "url": function (newV) {
            this.initDone = false;
            this.loadDataFromUrl();
        }

    },

    methods: {
        /**
         * 根据url加载数据
         */
        loadDataFromUrl() {
            this.$ajaxGet(this.url, res => {
                this.items = res.result;
                this.processChoosed();
            })
        },
        /**
         * 根据指定的options，生成选项
         */
        loadDataFromOptions() {
            this.items = this.options;
            this.processChoosed();
        },

        /**
         * 处理选中项
         */
        processChoosed() {

            if (this.initDone == false) { //未初始化完

                this.initDone = true;

            }

            let exist = this.optionsC.some(item => item.value == this.selected);
            if (exist) { //指定的值，在选项中存在，就用指定的值
                this.choosedValue = this.selected;
            } else if (this.defaultFirst && this.optionsC.length){ //指定的值不存在，而且设置了用默认第一个选项，就按第一个选项来
                this.choosedValue = this.optionsC[0].value;
            } else {
                this.choosedValue = this.noneValue;

            }
            if (this.choosedValue != this.selected) {
                this.$emit("change", this.choosedValue);
            }


        },






        changeOption(v) {
            if (v === "") { //清空，按照默认空值来算
                this.choosedValue = this.noneValue;
                v = this.noneValue;
            }
            this.$emit("change",v);
        },
    },


    created() {
        if (this.url) {
            this.loadDataFromUrl();
        } else {
            this.loadDataFromOptions();
        }
        console.log(this);
    }

}
</script>

<style scoped>

</style>
